import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import MultiSelectReact from 'react-multi-select-ext';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';

  
const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000' 
};


let selectAll = true
export default class QuizDropDown extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
          sectionListArray: [],
          selectedSectionIDs:-1,
          loading: true,
        };
      }

      
    //Loads All Sections for a given course on Component Mount
    componentWillMount() {
        console.debug("archive mode section ",this.props.archiveMode , this.props.sectionMap)
        if(!this.props.selectAll){
            selectAll = false
        }
        if(this.props.archiveMode && this.props.sectionMap){
            let sectionArray = [];
            if(this.props.perfDataMode !== true){
                sectionArray =   this.props.sectionMap[this.props.selectedCourseID].map(
                    this.makeSectionlistArrayArchive
                    );
            }else{
                sectionArray = sectionArray =   this.props.sectionMap.map(
                    this.makeSectionlistArray
                    );
            }
            

            this.setState({sectionListArray:sectionArray,loading: false},()=>{
                this.props.onChange(sectionArray);
            });
        }
        else 
            this.updateSections(this.props.selectedCourseID);
    }

    componentWillReceiveProps(nextProps)
    {
        
        if(this.props.selectedCourseID !== nextProps.selectedCourseID)
        {
            if(this.props.archiveMode && this.props.sectionMap && this.props.perfDataMode !== true){

                let sectionArray = [];
                if(this.props.perfDataMode !== true){
                    sectionArray =   this.props.sectionMap[nextProps.selectedCourseID].map(
                        this.makeSectionlistArrayArchive
                        );
                }else{
                    sectionArray = sectionArray =   this.props.sectionMap.map(
                        this.makeSectionlistArray
                        );
                }
                this.setState({sectionListArray:sectionArray,loading: false},()=>{
                    this.props.onChange(sectionArray);
                });
            }
            else    
                this.updateSections(nextProps.selectedCourseID);
            
        }
    }
    //Update Sections
    updateSections = (selectedCourseID) => 
    {
        if(selectedCourseID <= 0)
            return;
            
        let parent = this;
        let sectionListPromise =   this.getSectionData(selectedCourseID);
         sectionListPromise.then(sectionList => {
            if(sectionList.length > 0 )
            {
                let sectionArray    =   sectionList.map(
                    this.makeSectionlistArray
                    );
                parent.setState({sectionListArray:sectionArray,loading: false},()=>{
                    parent.props.onChange(sectionArray);
                });
            }else{
                //NotificationManager.error('ERROR','Selected Course hase No Section. Please Select a differetn Course.');
                parent.setState({loading:false})
            }
            
        }).catch(error => {
            console.error("error retriving sections ",error);
            this.setState({loading:false});
            NotificationManager.error(error,"Error - Empty Response",5000);
        })
    }
    //Create an Array of QuizList for Select Box
    makeSectionlistArray(sectionObj, index) {
        console.log('makeSectionlistArray',sectionObj)
        return {
            index: sectionObj.quiz_id,
            label: sectionObj.quiz_name,
            value: selectAll,
            id:sectionObj.quiz_id
        };
    }

    makeSectionlistArrayArchive(sectionObj, index) {
        console.log('makeSectionlistArrayArchive',sectionObj)
        
        return {
            index: sectionObj.quiz_id,
            label: sectionObj.quiz_name,
            value: true,
            id:sectionObj.quiz_id
        };
    }
    

    getSectionData = (req_course_id) => {
        const payload = { course_id: req_course_id.course_id, archiveMode:this.props.archiveMode, 
            section_id: this.props.sectionID,
            semesterID:this.props.selectedSemesterID};
    
        return new Promise(function(resolve, reject) {
          ApiRequestService({
            method: 'post',
            url: '/getAllQuiz',
            data: payload
          })
            .then(res => {
              if (
                res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null && 
                    res.data.data.quizes_list !== undefined &&
                    res.data.data.quizes_list !== null &&
                    res.data.data.quizes_list.length > 0
              ) {
                return resolve(res.data.data.quizes_list);
              } else {
                console.log('Quiz Data Empty');
                // NotificationManager.error("Assignment Data Empty",5000);
                let emptyArray = [];
                return resolve(emptyArray);
              }
            })
            .catch(error => {
              console.error('Error When Retriving Quiz Details ', error);
              reject(error, null);
            });
        });
      }
    //Memoize Function to stop hitting Go Server on Every Request
    //getSectionData = iMemoized.memoize(this.getSectionData);
    
    onQuizChange = (
        argSelectedSectionIDs) => {    
        this.setState({
          selectedSectionIDs: argSelectedSectionIDs,
        });
        if(this.props.onChange !== undefined && this.props.onChange !== null)
            this.props.onChange(argSelectedSectionIDs);
    };

    render(){

        if(this.state.loading && !this.props.NoLoader)
        {
            return <LoadingSpinner loading={this.state.loading} />
        }
        if(this.state.sectionListArray && this.state.sectionListArray.length > 0){
            return <MultiSelectReact
                options={this.state.sectionListArray}
                optionClicked={this.onQuizChange}
                selectedBadgeClicked={this.onQuizChange}
                selectedOptionsStyles={selectedOptionsStyles}
                optionsListStyles={optionsListStyles}
                enableSelectAllNone={this.props.showSelectAll ? this.props.showSelectAll : false}
                // enableSelectAllNone={true}
            
            />
        }else{
            return <p>No Sections Found</p>;
        }
        

    }
}

QuizDropDown.propTypes = {
    onChange: PropTypes.func,
    className:PropTypes.string,
    placeholder:PropTypes.string,
    selectBoxID:PropTypes.string.isRequired,
    archiveMode:PropTypes.bool
    };